import { createVuetify } from 'vuetify';

import { vuetifyOptionsS21 } from '@abaninja/util-vuetify-config';

export const vuetify = createVuetify(vuetifyOptionsS21);
